const isLoadingText = gettext('Loading...');

const AnButton = ({onHandleClick, btnAttr, loadingAttr}) => {
    let loadText = loadingAttr.loadingText ? loadingAttr.loadingText : isLoadingText;
    return(
        <React.Fragment>
            <button onClick={onHandleClick} className={btnAttr.btn} disabled={loadingAttr.isLoading}>
                {loadingAttr.isLoading && <div className="spinner-border spinner-border-sm mr-1" role="status">
                    <span className="visually-hidden">{loadText}</span>
                </div>}
                {loadingAttr.isLoading && loadText}
                {!loadingAttr.isLoading && btnAttr.text}
            </button>
        </React.Fragment>
    )
}

export default AnButton;
